import axios from "axios";
import S3Upload from 'react-s3-uploader/s3upload';
import { getAccessToken } from "../../utils/authentication.service";
import { UploadMediaRequest, UploadMediaResponse } from "../../types/media";

const BASE_URL = `${process.env.REACT_APP_API_URL}`;

const mediaUploadUrl = `${BASE_URL}/api/2.0/media/upload`;

export const uploadToS3 = (file: File): Promise<{ signResult: any; file: File }> => {
  return new Promise((resolve, reject) => {
    const fileName = file.name || 'media';

    new S3Upload({
      signingUrl: "/api/2.0/file_upload/initiate",
      signingUrlMethod: "POST",
      signingUrlHeaders: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
      server: BASE_URL,
      scrubFilename: (filename) => encodeURIComponent(filename.replace(/[^\w\d_\-.\s]+/ig, "")),
      signingUrlQueryParams: { originalName: encodeURIComponent(fileName) },
      contentDisposition: "auto",
      uploadRequestHeaders: {},
      onFinishS3Put: (signResult, file) => resolve({ signResult, file }),
      onError: (err) => reject(err),
      files: [file],
    });
  });
};

export const createMedia = async (payload: {
  signedUrl: string;
  width: number;
  height: number;
  contentType: string;
  mediaType: string;
}): Promise<UploadMediaResponse> => {
  const response = await axios.post(mediaUploadUrl, payload);
  return response.data;
};


export const uploadMediaApi = async (media: UploadMediaRequest["media"]): Promise<UploadMediaResponse> => {
  if (!media.file) throw new Error("No file provided");

  const { signResult } = await uploadToS3(media.file);

  return createMedia({
    signedUrl: signResult.signedUrl,
    width: media.width || 0,
    height: media.height || 0,
    contentType: media.contentType || media.file.type,
    mediaType: media.type,
  });
};
